import {
  StoryblokRevocationForm,
  RevocationForm,
} from './StoryblokRevocationForm'

export { StoryblokRevocationForm }
export type { RevocationForm }

export const dummyBlokRevocationFormStoryblok: RevocationForm = {
  _uid: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  subline:
    'für die SUNPOINT & WELLMAXX Bodyforming Club Mitgliedschaft',
  headline: 'Widerrufsformular für den Online-Vertragsabschluss',
  component: 'revocation-form',
  _editable:
    '<!--#storyblok#{"name": "revocation-form", "space": "235453", "uid": "a1b2c3d4-e5f6-7890-abcd-ef1234567890", "id": "0"}-->',
}
